import React from 'react';
import styled from 'styled-components';
import Icon from '../IconBase';

function AppointmentBookIcon(props: any) {
  if (!(props.width || props.height)) {
    props = Object.assign({ ...props }, { width: 20 });
  }

  return (
    <Icon data-icon={'appointmentBook'} fill='none' viewBox='0 0 20 21'
      {...props}>
      <g id='appointmentBook' stroke='currentColor' strokeLinecap='round'
        strokeLinejoin='round' strokeWidth='2' transform='translate(1.000000, 1.000000)'>
        <rect id='Rectangle' x='0' y='2'
          width='18' height='17' rx='2' />
        <line x1='4.5' y1='0.5' x2='4.5'
          y2='3.5' id='Line-10' />
        <line x1='13.5' y1='0.5' x2='13.5'
          y2='3.5' id='Line-10-Copy-2' />
        <line x1='0.5' y1='7.5' x2='17.5'
          y2='7.5' id='Line-11' />
        <g transform='translate(5.000000, 9.500000)' strokeLinecap='round' strokeLinejoin='round'>
          <polyline id='Path' points='7.61818225 0.8 2.51818195 5.9000003 0.2 3.58181835'></polyline>
        </g>
      </g>
    </Icon>
  );
}

export default styled(AppointmentBookIcon)``;